/**
 * Google Analytics Custom Dimensions
 * @readonly
 * @enum {object}
 */
export const GoogleAnalyticsCustomDimension = {
  SERVICE_SELECTION: {
    name: 'service_selection',
  },
  EXPERIMENT_EXPOSURE: {
    name: 'experiment_exposure',
  },
}
